<div *ngFor="let class of classesToDisplay; trackBy: trackByFn">
  <app-ontology-class-item [resClass]="class" [projectMember]="projectMember"> </app-ontology-class-item>
</div>
